export default __webpack_public_path__ + "static/media/perimeter.a145e08a.svg";